import { ResourceAnalysis } from "../components/resource-analysis";
import { DocumentsSection } from "../components/side-panel-sections/documents-section";
import { SidePanelLayout } from "../components/side-panel-sections/side-panel-layout";
import { CoverageRowData } from "../tables/coverage";

export type CoverageSidePanelContentProps = {
  data: CoverageRowData;
};

export function CoverageSidePanelContent({ data }: CoverageSidePanelContentProps) {
  return (
    <SidePanelLayout title="Coverage" subtitle={data.provider}>
      <ResourceAnalysis />

      <DocumentsSection resources={[data.originalData]} resourceType="Coverage" />
    </SidePanelLayout>
  );
}
